// Module
var code = `<div ng-click="\$ctrl.goBack()">
	<i class="fas fa-angle-left" aria-hidden="true"></i>
	<span class="back-button-title" ng-if="\$ctrl.title">{{::\$ctrl.title}}</span>
</div>
`;
// Exports
export default code;